<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :search="search" :items="items" :headers="headers">
      <template v-slot:item.id="{ item }">
        <span class="table-tutor-srno">{{ item.id }}</span>
      </template>

      <!--
      <template v-slot:item.group_name="{ item }">
        <span class="">{{ item.group_name }}</span>
      </template>
      <template v-slot:item.class_id="{ item }">
        
        <span class="table-tutor-name"> {{ item.class.class_name }}</span>
      </template>
         -->
      <template v-slot:item.tutor_id="{ item }">
        <!-- <router-link
                        class="profile-link"
                        active-class="active"
                        :exact="true"
                        :to="{name: 'GroupDetails',params:{id:item.id}}"
                > -->
        <span
          class="table-tutor-name"
          v-if="typeof item.tutor != 'undefined' && item.tutor != null"
        >
          {{ item.tutor.tutor_fname }} {{ item.tutor.tutor_lname }}</span
        >
        <!-- </router-link> -->
      </template>
      <template v-slot:item.group_name="{ item }">
        <router-link
          class="profile-link"
          active-class="active"
          :exact="true"
          :to="{
            name: 'GroupDetails',
            params: { id: item.group_id, is_free_assessment: item.is_free_assessment },
          }"
        >
          <span class="table-tutor-name">{{ item.group_name }}</span>
        </router-link>
      </template>
      <!--
      <template v-slot:item.subject_id="{ item }">
        {{ item.subject.subject_name }}
      </template>
      -->
      <template v-slot:item.days="{ item }">
        <v-chip v-for="day in item.days" :key="day">{{ days_formatter(day) }}</v-chip>
      </template>

      <template v-slot:item.time="{ item }">
        <span class="table-tutor-time">{{ item.start_time }} To {{ item.end_time }}</span>
      </template>

      <template v-slot:item.tutor="{ item }">
        <span class="table-tutor-tutor">{{ item.tutor.name }}</span>
      </template>
      <template v-slot:item.status="{ item }">
        <span class="table-tutor-time">{{ group_status_formatter(item.status) }}</span>
      </template>

      <template v-slot:item.action="{ item }">
        <router-link
          class="profile-link"
          active-class
          :exact="true"
          :to="{ name: 'EditGroup', params: { id: item.group_id } }"
        >
          <v-icon color="success" v-if="perms.g_edit">mdi-file-edit</v-icon>
        </router-link>
        <v-icon color="red" @click="confirmDelete(item)" v-if="perms.g_delete">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <!-- 
        <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Groups
        <span
                :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{count}}</span>
      </span>
            <v-spacer></v-spacer>
            <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
        </div> -->

    <delete-dialog
      @success="deleteGroup"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Group"
    ></delete-dialog>
  </v-card>
</template>

<script>
import DataTableMixin from "../../mixins/dataTable";
import DeleteRow from "../../mixins/deleteRow";
import DeleteDialog from "../Dialogs/DeleteDialog.vue";

export default {
  name: "GroupTable",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  props : {
    perms: Object

  },
  data() {
    return {
      search: null,
      dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        {
          text: "SrNo.",
          sortable: true,
          value: "group_id",
        },
        {
          text: "Group Name",
          value: "group_name",
          sortable: true,
        },
        // {text: "Group Code", value: "group_name", sortable: true},
        // {
        //   text: "Class",
        //   value: "class_id",
        //   sortable: true,
        // },
        {
          text: "Tutor Name",
          value: "tutor_id",
          sortable: false,
        },
        // {
        //     text: "Subject",
        //     value: "subject_id",
        //     sortable: false
        // },
        // {text: "Tutor Name", value: "tutor", sortable: true},
        // {text: "Days", value: "days", sortable: false},
        // {text: "Time", value: "time", sortable: false},
        // {text: "Status", value: "status", sortable: false},
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    deleteGroup() {
      this.deleteConfirmLoading = true;
      axios
      .delete(apiRoutes.groups.url + "/" + this.current_row.group_id)
        .then((response) => {
          this.getItems();
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
        })
        .catch((error) => {
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
          Toast.fire({
            icon: "error",
            title: "Cannot Delete Linked Groups!",
          });
        });
    },
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
    getItems() {
      this.loading = true;
      axios
        .get(apiRoutes.groups.url, {
          params: this.formQueryParams(),
        })
        .then((response) => {
          this.formalizeTable(response.data);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-tutor {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-email {
    font: 400 12px/13px Lato;
    color: #172b4d4d;
  }

  &-time {
    display: block;
    font: 400 12px/10px Lato;
    color: #0e0edff7;
  }

  &-days {
    font: 400 12px/15px Lato;
    color: #172b4db3;
  }

  &-tutor {
    font: 500 13.5px Gotham;
    color: #529b11;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>
